const SelfBuildingSquareSpinner = () => {
    return (
        <ul className="square-loader">
            {Array.from({ length: 16 }).map((val, index) => (
                <li key={index} />
            ))}
        </ul>
    );
};

export default SelfBuildingSquareSpinner;